import React from 'react'

const terms = () => {
  return (
    <div>
        <h3>TERMS</h3>
        <p>
        <br/>
By accessing the website at http://www.junaidjamshed.com/, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.
<br/>
USE LICENSE
<br/>
Permission is granted to temporarily download one copy of the materials (information or software) on Junaid Jamshed (Pvt.) Ltd's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license, you may not:
modify or copy the materials;
<br/>
use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
attempt to decompile or reverse engineer any software contained on Junaid Jamshed Pvt Ltd's website;
remove any copyright or other proprietary notations from the materials; 
<br/>or
transfer the materials to another person or "mirror" the materials on any other server.
<br/>
This license shall automatically terminate if you violate any of these restrictions and may be 
terminated by Junaid Jamshed Pvt ltd at any time. Upon terminating your viewing of these materials
 or upon the termination of this license, you must destroy any downloaded materials in your 
 possession whether in electronic or printed format.
 <br/>
DISCLAIMER
<br/>
The materials on Junaid Jamshed Pvt Ltd's website are provided on an 'as is' basis. Junaid Jamshed
 Pvt Ltd makes no warranties, expressed or implied, and hereby disclaims and negates all other 
 warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
Further, Junaid Jamshed Pvt Ltd does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
<br/>

LIMITATIONS
<br/>
In no event shall Junaid Jamshed Pvt Ltd be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Junaid Jamshed Pvt Ltd's website, even if Junaid Jamshed Pvt Ltd or a Junaid Jamshed Pvt Ltd authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
<br/>
ACCURACY OF MATERIALS
<br/>
The materials appearing on Junaid Jamshed Pvt Ltd's website could include technical, typographical, or photographic errors. Junaid Jamshed Pvt Ltd does not warrant that any of the materials on its website are 100% accurate, complete or current. Junaid Jamshed Pvt Ltd may make changes to the materials contained on its website at any time without notice. However, Junaid Jamshed Pvt Ltd does not make any commitment to update the materials.
<br/>
PRODUCT & SERVICE DESCRIPTIONS
<br/>
Whilst we try to display the colors of our products accurately on the Website, the actual colors you see will depend on your screen and we cannot guarantee that your screen's display of any color will accurately reflect the color of the product on delivery.

All items are subject to availability. We will inform you as soon as possible if the product(s) or service(s) you have ordered are not available and we may offer an alternative product(s) or service(s) of equal or higher quality and value otherwise the order had to be canceled.
<br/>
ACCEPTANCE OF YOUR ORDER
<br/>
Please note that completion of the online checkout process does not constitute our acceptance of your order. Our acceptance of your order will take place only when we dispatch the product(s) or commencement of the services that you ordered from us.

By completing and submitting the electronic order form (or proceeding through the 'checkout process') you are making an offer to purchase goods which, if accepted by us, will result in a binding contract. Neither submitting an electronic order form nor completing the checkout process constitutes our acceptance of your order.

If you supplied us with your email address when entering your payment details (or if you have a registered account with us), we will notify you by email as soon as possible to confirm that we have received your order.

All products that you order through the Website will remain the property of J. until we have received payment in full from you for those products.

If we cannot supply you with the product or service you ordered, we will not process your order. We will inform you via email or call, if you have already paid for the product or service, refund you in full as soon as reasonably possible.

J. Junaid Jamshed reserved the right to cancel your order in the case of but not limited to; unavailability of product, incorrectly listed price, or any other information. 
<br/>
DELIVERY OF YOUR ORDER
<br/>
J. products are sold on a delivery duty unpaid basis. The recipient may have to pay import duty or a formal customs entry fee prior to or on delivery. Additional taxes, fees or levies may apply according to local legislation and customers are required to check these details before placing an order for international delivery.

We will deliver to the home or office address indicated by you when you place an order.
We cannot deliver to PO boxes. All deliveries must be signed for upon receipt. We will try at least twice to deliver your order at the address indicated by you.

We reserve the right to cancel your purchase in the event nobody is available to sign for receipt.
You bear the risk for the products once delivery is completed.

Where possible, we try to deliver in one go. We reserve the right to split the delivery of your order, for instance (but not limited to) if part of your order is delayed or unavailable. In the event that we split your order, we will notify you of our intention to do so by sending you an e-mail to the e-mail address provided by you at the time of purchase. You will not be charged for any additional delivery costs.

We can entertain any changes to order provided if the order isn't dispatched yet. We will not be able to accept any order change requests once the order is dispatched (neither any refund or exchange will be possible in case of delivery outside Pakistan.) 
<br/>
LINKS
<br/>
We may have placed links on this Website to other websites which we think you may want to visit. We do not vet these websites and do not have any control over their contents. Except where required by applicable law, J. cannot accept any liability in respect of the use of these websites.
<br/>
MODIFICATIONS
<br/>
Junaid Jamshed Pvt Ltd may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.

GOVERNING LAW
These terms and conditions are governed by and construed in accordance with the laws of Pakistan and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.

COMPLAINTS PROCESS
We hope that you're pleased with any purchase you've made or the service you've received from J. and that you'll never have reason to complain - but if there's something you're not happy with, we'd like to put matters right, so please contact us straight away:

BY EMAIL

eshop@junaidjamshed.com

BY TELEPHONE

021 111 112 111 (9am - 10pm , Monday - Saturday )</p>
        </div>
  )
}

export default terms